import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col-md-6" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "invalid-feedback"
}

import { ref } from "vue";

// Form data

export default /*@__PURE__*/_defineComponent({
  __name: 'SendMessageForm',
  setup(__props) {

const formData = ref({
  name: "",
  email: "",
  message: "",
});

// Validation errors
const errors = ref({
  name: "",
  email: "",
  message: "",
});

// Form submission logic
const submitForm = () => {
  // Validate form fields
  if (!validateForm()) return;

  console.log("Form submitted:", formData.value);
  alert("Thank you for contacting us!");
  // Reset form and errors
  formData.value = { name: "", email: "", message: "" };
  errors.value = { name: "", email: "", message: "" };
};

// Form validation logic
const validateForm = () => {
  errors.value = { name: "", email: "", message: "" };

  if (!formData.value.name) {
    errors.value.name = "Name is required.";
  }
  if (!formData.value.email) {
    errors.value.email = "Email is required.";
  }
  // else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.value.email)) {
  //   errors.value.email = "Invalid email address.";}

  if (!formData.value.message) {
    errors.value.message = "Message is required.";
  }

  // Check if any errors exist
  return !Object.values(errors.value).some((error) => error);
};

return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Send Us a Message", -1)),
    _createElementVNode("form", {
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          for: "name",
          class: "form-label"
        }, "Name", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "name",
          class: _normalizeClass(["form-control", { 'is-invalid': errors.value.name }]),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
          placeholder: "Enter your name"
        }, null, 2), [
          [_vModelText, formData.value.name]
        ]),
        (errors.value.name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errors.value.name), 1))
          : _createCommentVNode("", true)
      ])), [
        [_directive_auto_animate]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _cache[4] || (_cache[4] = _createElementVNode("label", {
          for: "email",
          class: "form-label"
        }, "Email", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "email",
          id: "email",
          class: _normalizeClass(["form-control", { 'is-invalid': errors.value.email }]),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
          placeholder: "Enter your email"
        }, null, 2), [
          [_vModelText, formData.value.email]
        ]),
        (errors.value.email)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(errors.value.email), 1))
          : _createCommentVNode("", true)
      ])), [
        [_directive_auto_animate]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
        _cache[5] || (_cache[5] = _createElementVNode("label", {
          for: "message",
          class: "form-label"
        }, "Message", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "message",
          class: _normalizeClass(["form-control", { 'is-invalid': errors.value.message }]),
          rows: "4",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.message) = $event)),
          placeholder: "Enter your message"
        }, null, 2), [
          [_vModelText, formData.value.message]
        ]),
        (errors.value.message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(errors.value.message), 1))
          : _createCommentVNode("", true)
      ])), [
        [_directive_auto_animate]
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("button", {
        type: "submit",
        class: "btn btn-primary w-100"
      }, " Submit ", -1))
    ], 32)
  ]))
}
}

})